// `SameValueZero` abstract operation
// https://tc39.github.io/ecma262/#sec-samevaluezero
module.exports = function (x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y || x != x && y != y;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/same-value-zero.js
// module id = 1705
// module chunks = 1